if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/collections") || window.location.pathname.includes("/search")) {
    setTimeout(() => {
      const targetCart = document.querySelector(".shopify-section.has-m6cl");
      let flag = true;
      if (targetCart) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          if (flag) {
            setTimeout(() => {
              BSS_B2B.cp.changeProductPrice(JSON.parse($("#bss-b2b-store-data").html()), false, false, false);
            }, 1000);
          }
          flag = !flag;
        });
        mutationObserver.observe(targetCart, { childList: true, subtree: true });
      }
    }, 3000);
  }
}